import React, { useState, useEffect } from "react";
import { Table, Space, Button, Row, Col, Modal, Select, Tooltip } from "antd";
import { EditOutlined, EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import { GoArrowSwitch } from "react-icons/go";
import { Link, useNavigate } from "react-router-dom";
import employeeService from "../../../services/employee-service";
import { checkPermission } from "../../../utils/permissions";
import { changeDocumentTitle } from "../../../utils/title";

function Employees() {
  const navigate = useNavigate();
  const editEmployee = (id) => navigate(`/administrations/employees/form/${id}`);
  const [loading, setLoading] = useState(false);
  const [isModalshow, setIsModalShow] = useState();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [employee, setEmployee] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    total: 0,
    pageSize: 10,
  });
  const [filteredEmployees, setFilteredEmployees] = useState(employee);
  const options = [
    {
      value: "10",
      label: "10",
    },
    {
      value: "25",
      label: "25",
    },
    {
      value: "50",
      label: "50",
    },
  ];

  const columns = [
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "Name",
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "Address",
    },
    {
      title: "CNIC",
      dataIndex: "cnic",
      key: "CNIC",
    },
    {
      title: "Date Of Birth",
      dataIndex: "dob",
      key: "DateOfBirth",
    },
    {
      title: "Date Of Joining",
      dataIndex: "joining_date",
      key: "DateOfJoining",
    },
    {
      title: "Qualification",
      dataIndex: "qualification",
      key: "Qualification",
    },
    {
      title: "Salary",
      dataIndex: "salary",
      key: "Salary",
    },

    {
      title: "Designation",
      dataIndex: "designation",
      key: "Designation",
    },
    {
      title: "Username",
      dataIndex: "username",
      key: "Username",
    },
    {
      title: "Status & Action",
      key: "status",
      render: (_, record) => (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span
            style={{
              color: record.status === 1 ? "green" : "red",
              fontWeight: "bold",
            }}
          >
            {record.status === 1 ? "Active" : "Inactive"}
          </span>
          <Button
            style={{
              backgroundColor: "#2D3748",
              color: "white",
              borderRadius: "10px",
            }}
            onClick={() => showModalHandler(record)}
            size="small"
          >
            <GoArrowSwitch style={{ fontSize: "15px" }} />
          </Button>
        </div>
      ),
    },
    {
      title: "Operations",
      key: "Operations",
      fixed: "right",
      render: (text, record) => (
        <Space size="small">
          <Tooltip title='Edit'>
            <Button
              type="primary"
              size="small"
              onClick={() => editEmployee(record.id)}
            >
              <EditOutlined />
            </Button>
          </Tooltip>

          <Link to={`/administrations/employees/view/${record.id}`}>
            <Tooltip title='View'>
              <Button type="primary" size="small">
                <EyeOutlined />
              </Button>
            </Tooltip>
          </Link>

          {checkPermission("DELETE_EMPLOYEES") && <Tooltip title='Delete'>
            <Button type="primary" size="small">
              <DeleteOutlined onClick={() => showModalHandler(record, true)} />
            </Button>
          </Tooltip>}

        </Space>
      ),
    },
  ];

  const initialize = async (page = 1, pageSize = pagination.pageSize) => {
    setLoading(true);
    const { success, data } = await employeeService.fetch(page, pageSize);
    setLoading(false);
    if (success) {
      setEmployee(data.data);
      setFilteredEmployees(data.data);
      setPagination((prev) => ({
        ...prev,
        total: data.total,
        current: page,
        pageSize,
      }));
    }
  };

  const handleOk = async () => {
    if (!selectedRecord) return;
    setLoading(true);
    if (isModalVisible) {
      const response = await employeeService.deleteEmployee(selectedRecord.id);
      if (response?.success) {
        setEmployee((prevData) =>
          prevData.filter((item) => item.id !== selectedRecord.id)
        );
        setFilteredEmployees((prevData) =>
          prevData.filter((item) => item.id !== selectedRecord.id)
        );
        setIsModalVisible(false);
      }
    } else if (isModalshow) {
      const response = await employeeService.changeStatus(selectedRecord.id);
      if (response.success) {
        setEmployee((prevData) =>
          prevData.map((item) =>
            item.id === selectedRecord.id
              ? { ...item, status: item.status === 1 ? 0 : 1 }
              : item
          )
        );
        initialize(pagination.current, pagination.pageSize);
        setIsModalShow(false);
      }
    }
    setLoading(false);
    setSelectedRecord(null);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
    setSelectedRecord(null);
    setIsModalShow(false);
  };
  const showModalHandler = (record, isDelete = false) => {
    setSelectedRecord(record);
    if (isDelete) {
      setIsModalVisible(true);
    } else {
      setIsModalShow(true);
    }
  };

  useEffect(() => {
    changeDocumentTitle("Employees");
    initialize(pagination.current, pagination.pageSize);
  }, []);

  return (
    <div
      style={{
        padding: "5px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#FFFFFF",
      }}
    >
      <Row gutter={16} style={{ paddingTop: "5px" }}>
        <Col span={12}>
          <h1 style={{ fontWeight: "bold" }} className="pl-2 pt-3">
            Employees Table
          </h1>
        </Col>
      </Row>

      <Row
        gutter={8}
        style={{
          marginTop: "10px",
          background: "#F2F2F7",
          padding: "5px",

          alignItems: "center", // Ensures alignment of items within the row
        }}
      >
        {/* First Column: Left-Aligned */}
        <Col
          span={4}
          xs={24}
          sm={12}
          md={6}
          lg={4}
          style={{ display: "flex", alignItems: "center" }}
        >
          <Space direction="horizontal" size={10}>
            <p style={{ margin: 0 }}>Show</p>
            <Select
              defaultValue={pagination.pageSize.toString()}
              options={options}
              size="small"
              style={{ width: 70, fontSize: 14 }}
              onChange={(value) => {
                initialize(1, value);
              }}
            />
            <p style={{ margin: 0 }}>entries</p>
          </Space>
        </Col>

        {/* Second Column: Right-Aligned Search */}
        {/* <Col
          span={20}
          xs={24}
          sm={12}
          md={18}
          lg={20}
          style={{
            textAlign: "right",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <Input
            placeholder="Search"
            prefix={<SearchOutlined />}
            style={{
              width: "30%",
              borderRadius: "4px",
              fontSize: 14,
            }}
            value={searchTerm}
            onChange={handleSearch}
          />
        </Col> */}
      </Row>

      {/* status change action */}
      <Modal
        title={<div style={{ textAlign: "center" }}>Confirm</div>}
        open={isModalshow}
        onOk={handleOk}
        onCancel={handleCancel}
        centered
        style={{
          padding: "20px",
        }}
        width={300}
        footer={
          <div className="flex justify-center gap-3">
            <Button type="primary" onClick={handleOk} style={{ width: "30%" }}>
              Yes
            </Button>
            <Button
              type="default"
              onClick={handleCancel}
              style={{ width: "30%" }}
            >
              No
            </Button>
          </div>
        }
      >
        <p>
          Confirm change status to{" "}
          <strong>
            {selectedRecord?.status === 1 ? "Inactive" : "Active"}
          </strong>
          ?
        </p>
      </Modal>

      {/* delete modal */}
      <Modal
        title={<div style={{ textAlign: "center" }}>Confirm</div>}
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        centered
        style={{
          padding: "20px",
        }}
        width={300}
        footer={
          <div className="flex justify-center gap-3">
            <Button
              type="default"
              onClick={handleCancel}
              style={{ width: "30%" }}
            >
              Cancel
            </Button>
            <Button type="primary" onClick={handleOk} style={{ width: "30%" }}>
              Confirm
            </Button>
          </div>
        }
      >
        <p style={{ textAlign: "center" }}>
          Are you sure you want to delete this?
        </p>
      </Modal>

      <Table
        columns={columns}
        loading={loading}
        dataSource={filteredEmployees}
        scroll={{ x: "max-content" }}
        style={{ marginTop: "5px" }}
        pagination={{
          current: pagination.current,
          total: pagination.total,
          pageSize: pagination.pageSize,
          onChange: (page) => initialize(page, pagination.pageSize),
          showSizeChanger: false,
        }}
        rowKey="id"
      />
    </div>
  );
}
export default Employees;
